import script from "./AddOrganizationDocumentModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddOrganizationDocumentModal.vue?vue&type=script&setup=true&lang=ts"

import "./AddOrganizationDocumentModal.vue?vue&type=style&index=0&id=afe65e0a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-afe65e0a"]])

export default __exports__